/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Reordenar productos agotados al final del grid
(function () {
  function reorderSoldOut() {
    var grids = document.querySelectorAll('.product-list, .collection__products');
    grids.forEach(function (grid) {
      var items = Array.from(grid.children).filter(function (el) {
        return el.classList && (el.classList.contains('product-item') || el.querySelector('.product-item'));
      });
      if (!items.length) return;
      var available = [], soldOut = [];
      items.forEach(function (item) {
        var txt = (item.textContent || '').toLowerCase();
        var hasOutBadge = item.querySelector('[class*="sold-out"], [class*="agotado"]');
        var isOut = hasOutBadge || txt.includes('agotado') || txt.includes('sold out');
        (isOut ? soldOut : available).push(item);
      });
      available.concat(soldOut).forEach(function (el) { grid.appendChild(el); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorderSoldOut);
  } else {
    reorderSoldOut();
  }
  // Re-aplicar cuando se cargan más productos (filtros, paginación AJAX)
  document.addEventListener('collection:updated', reorderSoldOut);
  document.addEventListener('shopify:section:load', reorderSoldOut);
})();
